import React from 'react';
import usePlacesAutocomplete from 'use-places-autocomplete';
import { Combobox, ComboboxInput, ComboboxList, ComboboxOption, ComboboxPopover } from '@reach/combobox';
import "@reach/combobox/styles.css";

function GooglePlacesAutocompleteField({ formik }) {
    const {
        ready,
        value,
        setValue,
        suggestions: { status, data },
        clearSuggestions,
    } = usePlacesAutocomplete({ debounce: 300 });

    // Keep Formik and local state in sync
    React.useEffect(() => {
        if (formik.values.address !== value) {
            setValue(formik.values.address || '', false);
        }
        // eslint-disable-next-line
    }, [formik.values.address]);

    const handleInput = (e) => {
        setValue(e.target.value);
        formik.setFieldValue('address', e.target.value);
    };

    const handleSelect = (address) => {
        setValue(address, false);
        formik.setFieldValue('address', address);
        clearSuggestions();
    };

    return (
        <Combobox onSelect={handleSelect} aria-label="Address">
            <ComboboxInput
                name="address"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all duration-300"
                value={value}
                onChange={handleInput}
                disabled={!ready}
                placeholder="Start typing your address..."
                autoComplete="off"
            />
            <ComboboxPopover portal={false} className="z-[9999]">
                <ComboboxList>
                    {status === "OK" && data.map(({ place_id, description }) => (
                        <ComboboxOption key={place_id} value={description} />
                    ))}
                </ComboboxList>
            </ComboboxPopover>

          
        </Combobox>
    );
}

export default GooglePlacesAutocompleteField;
